import { render, staticRenderFns } from "./Kreativwerkstatt.vue?vue&type=template&id=c2f902c0&scoped=true"
import script from "./Kreativwerkstatt.vue?vue&type=script&lang=js"
export * from "./Kreativwerkstatt.vue?vue&type=script&lang=js"
import style0 from "./Kreativwerkstatt.vue?vue&type=style&index=0&id=c2f902c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f902c0",
  null
  
)

export default component.exports